import type { ExportedFile } from './types';

/** Hands a server-generated file to the browser's download. The file name is the server's (a sanitized `Content-Disposition` name). */
export function saveExportedFile(file: ExportedFile): void {
  const url = URL.createObjectURL(file.blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.fileName;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
